import React from 'react';

const NoResultsImage = () => {
    return <i className="onsolve-image onsolve-noresult-image" />;
};

NoResultsImage.displayName = 'NoResultsImage';

export default NoResultsImage;
